import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { IContainer } from "../containerModel";

export const getAllContainer = createAsyncThunk(
  "Container/FindAllContainer",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Container/FindAllContainer`,
        {
          container_type: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Service:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveContainer = createAsyncThunk(
  "Container/FindAllActiveContainer",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Container/FindAllActiveContainer`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Container:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createContainer = createAsyncThunk(
  "Container/InsertContainer",
  async (ContainerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Container/InsertContainer`,
        ContainerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Container:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateContainer = createAsyncThunk(
  "Container/UpdateContainer",
  async (ContainerData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Container/UpdateContainer`,
        ContainerData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Container:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getContainerByID = createAsyncThunk(
  "Container/FindByIDContainer",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Container/FindByIDContainer`,
        { container_guid: ID }
      );
      const result = response.data?.Data as any;
      return {
        container_type: result.container_type,
        container_guid: result.container_guid,
        isactive: result.isactive === true ? 1 : 2,
      } as IContainer;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Container:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ContainerActiveInactive = createAsyncThunk(
  "Container/ActiveInActiveContainer",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Container/ActiveInActiveContainer`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Container:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteContainer = createAsyncThunk(
  "Container/DeleteContainer",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Container/DeleteContainer`,
        { container_guid: ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting outcomeofservice:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
